import React from 'react';
import PropTypes from 'prop-types';
import Alert from '../elements/ReactBootstrap/Alert';
import PremiumAmount from "../elements/Values/PremiumAmount";

const SuccessfulPaymentWidget = ({
    amount,
    defaultCurrency,
}) => {
    return (<Alert variant="success" heading={<>Плащането за{' '}
        <PremiumAmount amount={amount} currency={defaultCurrency}/>
        е успешно!</>} />);
};

SuccessfulPaymentWidget.propTypes = {
    amount: PropTypes.number.isRequired,
    defaultCurrency: PropTypes.string,
};

export default SuccessfulPaymentWidget;
